import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { AuthService } from '@app/services';
import { environment } from '@env/environment';

export const authGuard: CanActivateChildFn = (childRoute, state) =>
{
    const router = inject(Router);
    const authService = inject(AuthService);

    if (environment.debug && !environment.verifyAuth) // only for testing purpose
    {
        return true;
    }

    if (authService.isLoggedIn())
    {
        return true;
    }

    return router.createUrlTree(['login']);
}
